import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

// Actions & service & constants
import { clearList, loadAppointmentsByPractId } from '../reducer/actions';
import { getAppointmentViewState } from 'src/services/functions';

// Components
import Table from '../components/Table/Table';
import TodayHeader from '../components/TodayHeader';

class TodayView extends Component {
  constructor() {
    super();
    this.state = { filterList: null };
    this.filteringByStatuses = this.filteringByStatuses.bind(this);
  }

  componentDidMount() {
    const { loadAppointmentsByPractId, practitionerId } = this.props;
    if (practitionerId) {
      loadAppointmentsByPractId(practitionerId, moment());
    }
  }

  componentDidUpdate(prevProps) {
    const {
      appointments: { list, filters: { selectedAppointmentStatus } },
      loadAppointmentsByPractId,
      practitionerId,
    } = this.props;

    // if change practitioner
    if (prevProps.practitionerId !== practitionerId) {
      loadAppointmentsByPractId(practitionerId, moment());
    }

    // if list changed or status filter changed
    if (
      prevProps
      && (JSON.stringify(prevProps.appointments.list) !== JSON.stringify(list)
        || JSON.stringify(prevProps.appointments.filters.selectedAppointmentStatus)
          !== JSON.stringify(selectedAppointmentStatus))
    ) {
      this.filteringByStatuses();
    }
  }

  componentWillUnmount() {
    this.props.clearList();
  }

  filteringByStatuses() {
    const {
      appointments: { list, filters: { selectedAppointmentStatus } },
      practitionerId,
    } = this.props;

    let filterList;    
    if (list && Array.isArray(list) && selectedAppointmentStatus) {
      filterList = list.filter((appointment) => {
        const appointStatus = getAppointmentViewState(appointment);
        return (selectedAppointmentStatus.find((statuses) => statuses.indexOf(appointStatus) > -1));
      });
    }
    if (filterList) {
      this.setState({ filterList });
    }
  }

  render() {
    const { openVerifyModal } = this.props;
    const { filterList } = this.state;
    return (
      <Fragment>
        <TodayHeader />

        <Table openVerifyModal={openVerifyModal} appointmentsList={filterList} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { practitioner } = state;
  return {
    appointment: practitioner.appointment,
    appointments: practitioner.appointments,
    practitionerId: practitioner.common.commonFilters.practitionerId,
  };
};

export default translate()(
  connect(
    mapStateToProps,
    { clearList, loadAppointmentsByPractId },
  )(TodayView),
);
